import Http from "@/utils/request.js"

// 用户信息
export const UserInfo = (data) => {
	return Http.request({
		url: '/stock/user/info',
		method: 'post',
		data
	})
}

// 开户
export const OpenAccount = data => {
	return Http.request({
		url: '/stock/accountApply/openAccountApply',
		method: 'post',
		data
	})
}

// 修改密码
export const ChangePassword = data => {
	return Http.request({
		url: '/stock/user/changePassword',
		method: 'post',
		data
	})
}

// 设置支付密码 
export const SetPayPassword = data => {
	return Http.request({
		url: '/stock/transferAccounts/setCjPwd',
		method: 'post',
		data
	})
}

// 是否设置支付密码 
export const IsSetPayPassword = data => {
	return Http.request({
		url: '/stock/transferAccounts/isOpen',
		method: 'post',
		data
	})
}

// 修改支付密码 
export const ChangePayPassword = data => {
	return Http.request({
		url: '/stock/transferAccounts/resetCjPwd',
		method: 'post',
		data
	})
}

//  修改用户信息
export const ChangeUserInfo = data => { 
	return Http.request({
		url: '/stock/user/changeUserInfo',
		method: 'post',
		data
	})
}

// 获取 kyc 状态
export const GetKycStatus = data => {
	return Http.request({
		url: '/stock/accountApply/applyDetail',
		method: 'post',
		data
	})
}